export const LIST_PRICE_CATEGORY_REQUEST = 'LIST_PRICE_CATEGORY_REQUEST'
export const LIST_PRICE_CATEGORY_SUCCESS = 'LIST_PRICE_CATEGORY_SUCCESS'
export const LIST_PRICE_CATEGORY_FAIL = 'LIST_PRICE_CATEGORY_FAIL'

export const LIST_PRICE_CATEGORY_SUMMARY_REQUEST =
  'LIST_PRICE_CATEGORY_SUMMARY_REQUEST'
export const LIST_PRICE_CATEGORY_SUMMARY_SUCCESS =
  'LIST_PRICE_CATEGORY_SUMMARY_SUCCESS'
export const LIST_PRICE_CATEGORY_SUMMARY_FAIL =
  'LIST_PRICE_CATEGORY_SUMMARY_FAIL'

export const CREATE_PRICE_CATEGORY_REQUEST = 'CREATE_PRICE_CATEGORY_REQUEST'
export const CREATE_PRICE_CATEGORY_SUCCESS = 'CREATE_PRICE_CATEGORY_SUCCESS'
export const CREATE_PRICE_CATEGORY_FAIL = 'CREATE_PRICE_CATEGORY_FAIL'

export const DETAIL_PRICE_CATEGORY_REQUEST = 'DETAIL_PRICE_CATEGORY_REQUEST'
export const DETAIL_PRICE_CATEGORY_SUCCESS = 'DETAIL_PRICE_CATEGORY_SUCCESS'
export const DETAIL_PRICE_CATEGORY_FAIL = 'DETAIL_PRICE_CATEGORY_FAIL'

export const UPDATE_PRICE_CATEGORY_REQUEST = 'UPDATE_PRICE_CATEGORY_REQUEST'
export const UPDATE_PRICE_CATEGORY_SUCCESS = 'UPDATE_PRICE_CATEGORY_SUCCESS'
export const UPDATE_PRICE_CATEGORY_FAIL = 'UPDATE_PRICE_CATEGORY_FAIL'

export const DELETE_PRICE_CATEGORY_REQUEST = 'DELETE_PRICE_CATEGORY_REQUEST'
export const DELETE_PRICE_CATEGORY_SUCCESS = 'DELETE_PRICE_CATEGORY_SUCCESS'
export const DELETE_PRICE_CATEGORY_FAIL = 'DELETE_PRICE_CATEGORY_FAIL'

export const RESET_PRICE_CATEGORY = 'RESET_PRICE_CATEGORY'
